import { useI18n } from '../i18n'
import { readJournal } from '../lib/journal'

export function Journal() {
  const { t, locale } = useI18n()
  const entries = readJournal().slice().reverse()
  const loc = locale === 'ru' ? 'ru-RU' : 'en-US'

  return (
    <section className="screen">
      <h2>{t.journal.title}</h2>
      <p className="lead">{t.journal.lead}</p>
      {!entries.length && <p className="muted" style={{ marginTop: 14 }}>{t.journal.empty}</p>}
      {entries.map((e) => {
        const d = new Date(e.d)
        const date =
          d.toLocaleDateString(loc, { day: 'numeric', month: 'long' }) +
          ' · ' +
          d.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' })
        return (
          <div className="post-card" key={e.id}>
            <img src={e.img} alt="" />
            <div className="post-body">
              <div className="post-date">{date}</div>
              <div className="post-state">{e.state}</div>
              {e.post && <div className="post-text">{e.post}</div>}
              <span className="post-kind">
                {e.type === 'therapy' ? t.journal.kindTherapy : t.journal.kindFree}
              </span>
              {typeof e.deltaSharp === 'number' && (
                <span className="post-kind" style={{ marginLeft: 6 }}>
                  {e.deltaSharp > 0 ? '−' : '+'}{Math.abs(e.deltaSharp)} pp
                </span>
              )}
            </div>
          </div>
        )
      })}
    </section>
  )
}
